import { useRemoteConfig } from '@funtech-int/yango-shared';

import { remoteConfigScheme, type BenefitType } from '../lib/remoteConfig';

export type { BenefitType };

export function useYangoOnboardingConfig() {
    const remoteConfig = useRemoteConfig(remoteConfigScheme);

    return remoteConfig.get('onboarding_config');
}
